import { DragDownHeaderNorlys } from '~src/components/Header/DragDownHeader';
import { SavingsWidgetNorlys } from '~src/components/SavingsWidget';
import { CompactSavingsWidgetNorlys } from '~src/components/SavingsWidget/Compact';
import { showTakeover } from '~src/components/SavingsWidget/util';
import { CALCULATOR_THANK_YOU_PAGE_NORLYS, CREATE_OFFER_ERROR_MESSAGE } from '~src/constants';
import { usePublicCalculatorContext } from '~src/context/PublicCalculatorContext';
import {
  customerDetailsFilledOut,
  formatSendOffersParameters,
  useInsertAndSendOffers,
} from '~src/hooks/graphql/useOffer';
import { useFinancingProvider } from '~src/hooks/useFinancingProvider';
import { LEAD_ORIGIN_NORLYS } from '~src/hooks/useLeadOrigin';
import { captureException } from '~src/sentry';
import { useAnalytics } from '~src/tracking/ga';

import { useCustomerContext } from '~src/context/CustomerContext';
import { useToasters } from '~src/context/ToasterContext';
import { useHeaderSavingsEstimate } from '~src/hooks/NorlysInformationPage';
import { useCookie } from '~src/hooks/useCookie';

export const InformationPageHeaderMobileNorlys = () => {
  const context = usePublicCalculatorContext();
  const { customer } = useCustomerContext();

  const { takeover } = context;

  const showToaster = useToasters();

  const { quoteSent } = useAnalytics();
  const { fetching, insertOffers: sendOffers } = useInsertAndSendOffers();

  const { provider: financingProvider } = useFinancingProvider();

  const savingsEstimate = useHeaderSavingsEstimate();

  const handleError = (error: unknown) => {
    showToaster({ message: CREATE_OFFER_ERROR_MESSAGE, type: 'error' });
    captureException(error);
  };

  const { cookie: utmCookie } = useCookie('utmFields');
  const { cookie: gclidCookie } = useCookie('gclid');

  return (
    <DragDownHeaderNorlys
      {...{
        collapsedChildren: (
          <CompactSavingsWidgetNorlys {...{ ...savingsEstimate }} takeover={showTakeover(['heatPump'], takeover)} />
        ),
      }}
    >
      <SavingsWidgetNorlys
        {...{
          ...context,
          ...savingsEstimate,
          takeover: showTakeover(['heatPump'], takeover),
          type: 'frontend',
          button: {
            type: 'swipe',
            onClick: () =>
              sendOffers(
                formatSendOffersParameters({
                  ...context,
                  customer: {
                    ...customer,
                    utmFields: utmCookie ? JSON.parse(utmCookie) : undefined,
                    googleClickId: gclidCookie,
                  },
                  leadOrigin: LEAD_ORIGIN_NORLYS,
                  financingProvider,
                })
              )
                .catch(handleError)
                .then(result => {
                  if (result?.error) {
                    handleError(result.error);
                    return;
                  }

                  quoteSent(customer?.email ?? undefined);

                  window.location.href = CALCULATOR_THANK_YOU_PAGE_NORLYS;
                }),
            label: fetching ? 'Opretter tilbud...' : 'Modtag tilbud',
            disabled: fetching || !customerDetailsFilledOut(customer ?? {}),
          },
        }}
      />
    </DragDownHeaderNorlys>
  );
};
